module.exports = __webpack_public_path__ + "img/completar-perfil.0b6cb63d.gif";